var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuoyuan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.54187,
    y: 7.54187,
    width: 2.91628,
    height: 2.91628,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 7.31122C14.7421 5.87208 14.4772 4.78487 13.8462 4.15383C13.2151 3.52278 12.1279 3.25791 10.6888 3.59002C9.26547 3.91847 7.65118 4.81034 6.23077 6.23075C4.81036 7.65116 3.91849 9.26546 3.59004 10.6887C3.25793 12.1279 3.5228 13.2151 4.15385 13.8461C4.78489 14.4772 5.8721 14.7421 7.31124 14.4099C8.73453 14.0815 10.3488 13.1896 11.7692 11.7692C13.1896 10.3488 14.0815 8.73451 14.41 7.31122ZM12.4615 12.4615C15.5203 9.40271 16.4502 5.37327 14.5385 3.46152C12.6267 1.54977 8.59727 2.47964 5.53846 5.53844C2.47965 8.59725 1.54978 12.6267 3.46154 14.5384C5.37329 16.4502 9.40273 15.5203 12.4615 12.4615Z",
    fill: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuoyuan);
export default __webpack_public_path__ + "static/media/tuoyuan.4552e4ec9f7fbb185c45802962659e38.svg";
export { ForwardRef as ReactComponent };